// Airline configurations — public bundle contains ONLY the default (generic) config.
// Airline-specific configs live server-side and are fetched after authentication
// from /api/pitch/:code/data. See backend/airlines_seed.py.

export const airlines = {
  default: {
    id: "default",
    name: "Aeroplay",
    brandColor: null,
    accentColor: "#FFD700",
    pitchTitle: null,
    pitchLocation: null,
    logo: null,
    icon: null,
    hideSlides: ["commercial"],
    extraSlides: [],
    hideLetsPlay: false,
    extraCTAs: [],
    features: {}
  }
};

// Legacy export retained for imports that expect an array. Public bundle exposes
// only the generic entry — no airline directory.
export const airlineList = Object.values(airlines);
